
import { mapGetters } from "vuex";
import BrandAvatarWithColor from "../common/brand-avatar-with-color.vue";
export default {
  components: {
    BrandAvatarWithColor
  },
  data() {
    return {
      iconOffset: 13
    };
  },
  props: {
    brands: {
      default: []
    }
  },
  computed: {
    ...mapGetters("restaurant", ["getRestaurantName"])
  }
};
